$(function () {
    'use-strict';

    let $rowDateTmpl = $('#row-prize-date-tmpl');
    $rowDateTmpl.attr('id', '').removeClass('hidden').remove();

    function addDate(e) {
        let $el = $(e.target);
        let $prize = $el.closest('.row-prize');
        let $date = $el.closest('.row-prize-date');
        let $dates = $prize.find('.prize-dates');
        let $clone = $rowDateTmpl.clone();
        let prizeIndex = $prize.find('input[name*="[index]"]').val();
        let dateIndex = $dates.data('index');

        // Set the correct dateIndex if it's undefined.
        if (!dateIndex) {
            if ($dates.children().length > 0) {
                dateIndex = $dates.children('.row-prize-date').length + 1;
            } else {
                dateIndex = 0;
            }
        }

        $clone.find('input').each((index, el) => {
            let $el = $(el);
            let name = $el.prop('name');

            // Set the correct indexes to the arrays (prop name).
            name = name.replace(/^(prizes\[)(\d+)(\].*)$/, '$1' + (prizeIndex) + '$3');
            name = name.replace(/^(prizes\[\d+]\[dates\]\[)(\d+)(\].*)$/, '$1' + dateIndex + '$3');
            $el.prop('name', name);

            if (/^prizes\[\d+]\[dates\]\[\d+\]\[index\]$/.test(name)) {
                // Set the correct index to value the input field with [index] in prop name.
                $el.val(dateIndex);
            }
        });

        if (e.type === 'change') {
            $dates.append($clone);
        } else {
            $date.after($clone);
        }

        $dates.data('index', ++dateIndex);
    }

    function removeDate(e) {
        let $el = $(e.target);
        let $prize = $el.closest('.row-prize');
        let $date = $el.closest('.row-prize-date');
        let $dates = $prize.find('.prize-dates');
        let $dateWithId = $date.find('input[name*="[id]"]');

        if (e.type === 'change') {
            // Remove all dates if user switch to "no custom dates".
            $dates.find('.remove-prize-date').each((index, el) => {
                $(el).trigger('click');
            });
        }

        if ($dateWithId.length) {
            // Add prize to list of prizes to be removed.
            let $form = $prize.closest('form');
            $form.prepend('<input type="hidden" name="prize_dates_to_delete[]" value="' + $dateWithId.val() + '" />');
        }

        $date.remove();

        if (!$dates.children().length) {
            // Switch custom_dates if there is no custom_dates.
            $prize.find('input[name*="[custom_dates]"][value="false"]').prop('checked', true);
        }
    }

    // Check interaction with custom_dates
    $(document).on('change', 'input[name*="[custom_dates]"]', (e) => {
        if ($(e.target).val() === 'true') {
            addDate(e);
        } else {
            removeDate(e);
        }
    });

    // Interaction with (+) button.
    $(document).on('click', '.add-prize-date', (e) => {
        addDate(e);
    });

    // Interaction with (-) button.
    $(document).on('click', '.remove-prize-date', (e) => {
        removeDate(e);
    });
});
